<template>
    <div class="contacto">
            <div class="main col-lg-12">
                <h5 class="col-lg-12 mb-5 mt-5 pt-5">Panel - Pie de Página.</h5>
                
                <div class="container " id="top">
                   
                       <div class="row mb-5">
                    <div class="col-lg-2 col-sm-12" v-for="footer in footersComputed" :value="footer.value" :key="footer.value">
                        <div class="text-left" v-for="(title,key) in footer" :value="title.value" :key="title.value">
                          <div class="d-flex">
                            <h5 class="titulo">{{key}}</h5>
                            <b-link :title="'Editar '+ key" class="ml-5 btnEdit" @click="editFooter(key)"></b-link>
                          </div>
                          <div class="d-flex space-between">
                            <ul class="list-unstyled text-small">
                                <li v-for="(item) in title" :value="item.value" :key="item.value">
                                    <a class="text-footer text-muted" :href="item.url">{{item.valor}}</a>
                                </li>
                            </ul>
                            <div class="vr"/>
                          </div>
                        </div> 
                    </div>
                     <div class="col-lg-4 col-sm-12 text-left"> 
                       <div class="d-flex ">
                         <p class="titulo">Cliker</p>
                         <b-link :title="'Editar Cliker'" class="ml-5 btnEdit" @click="editFooter('Cliker')"></b-link>
                       </div>
                        <div class="" v-for="items in cliker" :value="items.value" :key="items.value">
                           <p class="text-footer text-muted"> 
                                {{items.valor}}
                            </p>
                        </div>
                    </div>
                </div>
                    
                    <h3>¡Puedes ver los cambios en esta misma página!</h3>
                    <h3 class="arrow-down"></h3>
                </div>
          

  

    <b-modal ref="footer-modal" id="footer-modal" no-close-on-backdrop scrollable hide-header>
     <div class="d-block text-center">
        <div class="col-lg-12 text-right">
                  <h2>Editar {{form_title}}</h2>
                  
      
                   <ValidationObserver ref="form" >
                      <b-form id="form" class="form-container">
                         <div class="row">
                           <div class="col-lg-12">
                              <b-button pill class="btnSend float-right" title="Añadir elemento" @click="addFooter(form_title)"><i class="fa fa-plus mr-3"></i> Añadir</b-button>
                            </div>
                            <div class="col-lg-12">
                              <div v-if="!textArea" class="form-group">
                                <label >Título</label>
                                  <ValidationProvider rules="required" v-slot="{ errors }">
                                      <b-form-input v-model="valor" name="valor"  type="text" placeholder="Título"/>
                                      <span class="error">{{ errors[0] }}</span>
                                  </ValidationProvider>
                              </div>
                              <div v-if="!textArea" class="form-group">
                                <label >URL o Valor</label>
                                  <ValidationProvider v-slot="{ errors }">
                                      <b-form-input v-model="url" name="url" type="text" placeholder="URL o Valor"/>
                                      <span class="error">{{ errors[0] }}</span>
                                  </ValidationProvider>
                              </div>
                              <div v-if="textArea"  class="form-group">
                                  <label >Contenido</label>
                                  <ValidationProvider rules="required" v-slot="{ errors }">
                                      <b-form-textarea v-model="valor" rows="6" name="descripcion"  placeholder=""/>
                                      <span class="error">{{ errors[0] }}</span>
                                  </ValidationProvider>
                              </div>
                            </div>
                            
                          </div>
                          <hr/>
                        <div v-for="(item,key) in selectedFooter" :value="item.value" :key="item.value">
                          <div class="row">
                            <div class="col-lg-12">
                              <b-link :title="'Eliminar '+ item.valor" class="btnDelete" @click="removeFooter(key,item)"></b-link>
                            </div>
                            <div class="col-lg-12">
                              <div v-if="!textArea" class="form-group">
                                <label >Título</label>
                                  <ValidationProvider v-slot="{ errors }">
                                      <b-form-input v-model="selectedFooter[key].valor" name="valor1" @input="changeFooter(item)" type="text" placeholder="Título"/>
                                      <span class="error">{{ errors[0] }}</span>
                                  </ValidationProvider>
                              </div>
                              <div v-if="!textArea" class="form-group">
                                <label >URL o Valor</label>
                                  <ValidationProvider v-slot="{ errors }">
                                      <b-form-input v-model="selectedFooter[key].url" name="url1" @input="changeFooter(item)" type="text" placeholder="URL o Valor"/>
                                      <span class="error">{{ errors[0] }}</span>
                                  </ValidationProvider>
                              </div>
                              <div v-if="textArea" class="form-group">
                                  <label >Contenido</label>
                                  <ValidationProvider v-slot="{ errors }">
                                      <b-form-textarea v-model="selectedFooter[key].valor" rows="6" @input="changeFooter(item)" name="descripcion1"  placeholder=""/>
                                      <span class="error">{{ errors[0] }}</span>
                                  </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <hr v-if="key+1 != selectedFooter.length"/>
                        </div>
                      </b-form>
                    </ValidationObserver>
        </div>
      </div>
    <template #modal-footer="{}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button v-show="!loading" type="submit" pill class="btnSend" @click="onSubmit()">Guardar Cambios</b-button>
      <b-link v-show="!loading" class="btnCancel" @click="reset();"><b-icon icon="x"></b-icon></b-link>
      <b-button v-show="loading" class="btnSend" pill disabled="disabled"><b-spinner small class="mr-2"></b-spinner>ENVIANDO</b-button>
    </template>
  </b-modal>
                <!--main-center"-->
            </div><!--main-->
    </div>
</template>

<script>

import env from '@/plugins/enviroment';
import footerApi from "../api/footer";
import {ValidationProvider,ValidationObserver} from 'vee-validate';
import {mapState,mapActions} from "vuex";
import Notify from "@/plugins/notify";
import Swal from "sweetalert2";


export default {
  name: 'footer-manager',
  components: {
      ValidationProvider,
      ValidationObserver,
  },
  data() {
      return {
        form_title:"",
        footers:[],
        footersObj:[],
        selectedFooter:[],
        footerPackage:{footer:[],eliminados:[]},
        valor:"",
        url:"",
        cliker:null,
        loading:false,
        textArea:false,
        timeout:null
      }
    },
     computed: {
       ...mapState("footer",["charge"]),
          footersComputed(){
                this.footers.find(element => {
               if(element.Contacto){
                   element.Contacto.forEach(item =>{
                        if(item.valor.includes("@")){
                            item.url = "mailto:"+item.valor;
                        }else{
                            item.url = "tel:"+item.valor;
                        }
                   });

               }
            });
            return this.footers;
          } 
      },
    methods: {
      ...mapActions("footer",["chargeFooter"]),
      async addFooter(name){
        var isValid = await this.$refs.form.validate();
        if (!isValid) {
          Notify.WarningToast("Tienes que completar los campos antes de crear un elemento nuevo.");
        }else{
          this.selectedFooter.unshift({id:0,titulo:name,valor:this.valor,url:this.url});
          this.footerPackage.footer.unshift({id:0,titulo:name,valor:this.valor,url:this.url});
          this.$nextTick(() => {
            this.$refs.form.reset();
            this.valor = "";
            this.url = "";
          });
        }
      },
      removeFooter(index,data){
        console.log("data",data);
        this.selectedFooter.splice(index,1);

        var fpIndex = this.footerPackage.footer.findIndex((element) => element.id  == data.id);
        
        if(data.id !=0 ){
          if(fpIndex >= 0){
            this.footerPackage.footer.splice(fpIndex,1);
          }
          this.footerPackage.eliminados.push(data.id);
        }else{
          console.log("index",index);
          this.footerPackage.footer.splice(index,1);
        }
        console.log(this.footerPackage);
      },
      changeFooter(data) {
        console.log("data",data);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          console.log("valor",data.valor);
          var fpIndex = this.footerPackage.footer.findIndex((element) => element.id  == data.id);
        
          if(fpIndex < 0){
            this.footerPackage.footer.push({id:data.id,titulo:data.titulo,valor:data.valor,url:data.url});
          }else{
            this.footerPackage.footer[fpIndex].valor = data.valor;
            this.footerPackage.footer[fpIndex].url = data.url;
          }

          console.log(this.footerPackage);
        },500);
      },
      editFooter(name){
          for(let i=0;i < this.footersObj.length;i++){
            let items = this.footersObj[i];
            if(typeof items[name] === 'object'){
              this.selectedFooter = JSON.parse(JSON.stringify(items[name]));
            }
          }

          if(name == "Cliker"){
            this.textArea = true;
          }else{
            this.textArea = false;
          }

        this.form_title = name;
        this.$refs['footer-modal'].show();
      },
      onSubmit(){
        this.updateFooter();
      },
      getFooter(){
            footerApi
            .getFooter()
            .then(response => {
                let footer = response.data;
                
                this.footersObj= JSON.parse(JSON.stringify(footer));
                this.cliker = footer.shift();
                this.cliker = this.cliker.Cliker;
                this.footers = footer;
            }).catch(err => {
                console.log("Ocurrio un error al cargar el footer.");
            });
        },
    async updateFooter(){
      this.loading = true;
      console.log(this.footerPackage);
       await footerApi
          .updateFooter(this.footerPackage)
          .then(response => {
            Notify.Success("¡Excelente!", "El Pie de Página se actualizó con éxito.");
            this.reset();
            this.$refs['footer-modal'].hide();
            this.getFooter();
            this.chargeFooter(true);
          }).catch(err => {
            Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible actualizar el pie de página, inténtalo nuevamente.");
          });
    
      this.loading = false;
    },
    reset() {
      this.$nextTick(() => {
          this.$refs.form.reset();
          this.form_title="";
          this.selectedFooter=[];
          this.footerPackage={footer:[],eliminados:[]};
          this.url = "";
          this.valor = "";
          this.loading=false;
          this.textArea=false;
          this.$refs['footer-modal'].hide();
          window.location = "#top";
        });
      },
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    init(){
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera;
      this.getFooter();
    }
    },
    created () {
      this.init();
    },
}
</script>

<style scoped>
h3{
  font-family: Muli;
font-style: normal;
font-weight: normal;
font-size: 38px;
line-height: 50px;
align-items: center;
text-align: center;
letter-spacing: 0.2px;
color: #1E2144;
}
.btnEdit{
    content: url("/static/images/icons/edit.svg");
  }

.arrow-down{
    content: url("/static/images/icons/arrow-down.svg");
    margin-right: auto;
    margin-left: auto;
    padding-top:28px;
  }

.vr{
    border-left:0.701478px solid #E0E0E0;
    height:180px;
  }
hr{
  border: 1px solid #E8404E;
}
.btnDelete{
    content: url("/static/images/icons/delete.svg");
  }

.social-part .fa{
        padding-right: 20px;
    }

    .titulo {
        font-family: Muli-Extrabold;
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        align-items: center;
        text-align: justify;
        letter-spacing: 0.2px;

        color: #1E2245;
    }

    ul > li {
        text-align: left;
    }

    .text-footer {
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 9px;
        line-height: 18px;
        align-items: center;
        letter-spacing: 0.2px;

        color: #1E2245;
    }

    p.text-footer {
        text-align: justify !important;
    }

    .social_btn_m {
        width: 100%;
        padding:10px 10px 10px 10px;
        background:rgb(60, 101, 177,0.3);
        border-radius: 15.0978px;
    }

h2{
  font-family: Muli;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 50px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.2px;
  color: #1E2245;
}

.error{
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    color:red;
}
    h5 {
        font-family: Muli;
        font-style: normal;
        font-size: 38px;
        line-height: 18px;

        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2144;

    }
    .btnDemo {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnDemo:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

 .btnSend {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    padding: 13px 40px;
  }

  .btnCancel {
    content: url("/static/images/icons/cancel.svg");
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    border-radius: 150px;
    background-color: #F2F2F2;
    border-color: #F2F2F2;
    display: block;
    padding:16px;
    transition:0.2s;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
  .btnCancel:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .cliker-text{
      color:#2DB9D1;
  }

    .main{
        padding: 40px 0;
        background:  url("/static/images/bg_azul_categoria.svg") repeat-x;
    }
    .main input {
        font-size: 11px;
        padding-top: 3px;
        border: 1px solid #E0E0E0;
        border-radius: 5px;
    }
    .main-center{
        margin-top: 30px;
        margin-bottom: 120px !important;
        margin: 0 auto;
        max-width: 600px;
        padding: 10px 40px;
        background:#FFFFFF;
        text-shadow: none;
        -webkit-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        -moz-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        border-radius: 25px;
    }

    .form-container {
        padding: 50px 0px;
    }
  .form-group{
    margin-bottom: 30px;
  }
    .form-group > label {
        font-family: Muli;
        font-style: normal;
        font-size: 16px;
        line-height: 16px;
        float:left;
        margin-left:20px;
        letter-spacing: 2px;
        color: #1E2144;
    }
    .placeholder {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 30px;

        display: flex;
        align-items: center;

        color: #BDBDBD;
    }

    .help {
        margin-top: 50px;
    }

    span.input-group-addon i {
        color: #009edf;
        font-size: 17px;
    }

     @media(max-width: 768px){
          h5 {
        font-size: 24px;
        line-height: 35px;
        margin: 0px 0px;
    }

        .main-center{
      
        background: none;
        -webkit-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        -moz-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        }

.btnSend {
    width: 100%;
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
        
     }
</style>